import * as React from "react";
import cx from "classnames";

import "./SignUp.css";

export interface SignUpProps {
  passwordAValue: string;
  passwordBValue: string;
  formMsg: string;
  isError: boolean;
  isLoading: boolean;
  handlePasswordAChange: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  handlePasswordBChange: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const getFormMsgClasses = ({ isError }: SignUpProps) =>
  cx("order-success-signup__form-msg", {
    "order-success-signup__form-msg--error": isError,
  });

const SignUp = (props: SignUpProps) =>
  <div>
    <form className="signup-form form-horizontal" onSubmit={props.handleSubmit}>
      <h3 className="help-text">
        Chúng tôi đã tạo tài khoản Express Design cho bạn, trong lúc chờ đợi,
        hãy thiết lập mật khẩu
      </h3>
      <div className="form-group">
        <label
          htmlFor="order-success-passwordA"
          className="col-md-3 control-label"
        >
          Mật khẩu
        </label>
        <div className="col-md-9">
          <input
            id="order-success-passwordA"
            className="form-control"
            type="password"
            value={props.passwordAValue}
            onChange={props.handlePasswordAChange}
            disabled={props.isLoading}
          />
        </div>
      </div>
      <div className="form-group">
        <label
          htmlFor="order-success-passwordB"
          className="col-md-3 control-label"
        >
          Nhập lại mật khẩu
        </label>
        <div className="col-md-9">
          <input
            id="order-success-passwordB"
            className="form-control"
            type="password"
            value={props.passwordBValue}
            onChange={props.handlePasswordBChange}
            disabled={props.isLoading}
          />
        </div>
      </div>
      <div className="form-group form-buttons">
        <div className="col-md-offset-3 col-md-9">
          <button
            className="form-button"
            type="submit"
            disabled={props.isLoading}
          >
            Đăng ký
            {props.isLoading && <i className="fa fa-fw fa-pulse fa-spinner" />}
          </button>
        </div>
      </div>
      <div className={getFormMsgClasses(props)}>
        <p>
          {props.formMsg}
        </p>
      </div>
    </form>
  </div>;

export default SignUp;



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/SignUp.tsx